import {
  ArrowTopRightOnSquareIcon,
  LockClosedIcon,
} from '@heroicons/react/24/solid';

import { InfoCallout } from '@/components/ui/info-callout';

interface InternalCapabilityCalloutProps {
  onLearnMore?: () => void;
}

/**
 * InternalCapabilityCallout - Explains why an Aegis agent is required for internal capabilities
 *
 * Displays an informational callout when a capability has surface === 'internal',
 * explaining that internal capabilities scan internal network resources and must
 * be executed through a deployed Aegis agent.
 */
export function InternalCapabilityCallout({
  onLearnMore,
}: InternalCapabilityCalloutProps) {
  const handleLearnMoreClick = () => {
    onLearnMore?.();
  };

  return (
    <InfoCallout
      role="region"
      aria-label="Internal capability information"
      data-testid="internal-capability-callout"
      className="p-4"
      icon={
        <LockClosedIcon
          className="size-5"
          data-testid="internal-capability-lock-icon"
          aria-hidden="true"
        />
      }
    >
      <div className="flex flex-col gap-2">
        <h4 className="text-sm font-semibold tracking-wide uppercase">
          INTERNAL CAPABILITY
        </h4>
        <p>
          This capability scans internal network resources and must be executed
          through an Aegis agent deployed in the target environment.
        </p>
        <button
          type="button"
          onClick={handleLearnMoreClick}
          className="text-chariot-brand-primary hover:text-chariot-brand-primary/80 inline-flex items-center gap-1 font-medium focus:underline focus:outline-hidden"
        >
          Learn more about Aegis agents
          <ArrowTopRightOnSquareIcon className="size-4" aria-hidden="true" />
        </button>
      </div>
    </InfoCallout>
  );
}
